<form [formGroup]="form">
  <div mat-dialog-title
       class="title">
    <div class="subtitle">{{ data.title }}</div>
  </div>
  <mat-dialog-content>

    <fieldset [disabled]="isSubmitting">

      <div class="line line-margin">
        <mat-form-field [hintLabel]="''">
          <mat-label class="required">{{ 'TestName' | translate }} (EN)</mat-label>
          <input matInput
                 formControlName="name_en"
                 [required]="true"/>
          <mat-hint align="end">{{ form.controls["name_en"].value.length }} / {{ NAME_MAX_LENGTH }}</mat-hint>
          <mat-error *ngIf="f['name_en'].invalid">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field [hintLabel]="''">
          <mat-label class="required">{{ 'TestName' | translate }} (FR)</mat-label>
          <input matInput
                 formControlName="name_fr"
                 [required]="true"/>
          <mat-hint align="end">{{ f["name_fr"].value.length }} / {{ NAME_MAX_LENGTH }}</mat-hint>
          <mat-error *ngIf="f['name_en'].invalid">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <div class="line">
        <div class="legend">{{ 'Measures' | translate }}</div>
      </div>

      <div formArrayName="metrics">
        <div *ngFor="let form of metrics.controls; let i = index;" class="line" [formGroupName]="i">
          <mat-form-field [hintLabel]="''">
            <mat-label class="required">{{ 'Name' | translate }} (EN)</mat-label>
            <input matInput
                   formControlName="name_en"
                   [required]="true"/>
            <mat-error *ngIf="form['controls'].name_en.invalid">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>
          <mat-form-field [hintLabel]="''">
            <mat-label class="required">{{ 'Name' | translate }} (FR)</mat-label>
            <input matInput
                   formControlName="name_fr"
                   [required]="true"/>
            <mat-error *ngIf="form['controls'].name_fr.invalid">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field color="primary">
            <mat-select placeholder="{{'Unit' | translate}}"
                        formControlName="unit">
              <mat-option *ngFor="let unit of (units$ | async)" [value]="unit.id">
                {{ unit.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="false">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>

          <button mat-icon-button
                  [matTooltip]="'EditBorgScale' | translate"
                  [color]="borgScales[i] === undefined ? 'primary' : 'accent'"
                  (click)="editBorg(i)">
            <mat-icon>functions</mat-icon>
          </button>
          <button *ngIf="!isEditForm" mat-icon-button
                  [matTooltip]="'Remove' | translate"
                  (click)="removeMetric(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!isEditForm" class="add-button-container">
        <button *ngIf="metrics.controls.length < 5"
                mat-mini-fab
                color="accent"
                [matTooltip]="'New_metric' | translate"
                (click)="addMetric()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="line">
        <mat-form-field color="primary">
          <mat-select formControlName="borgMetric"
                      placeholder="{{'BorgMetric' | translate}}">
            <mat-option *ngFor="let b of borgMetrics$ | async" [value]="b.index">
              {{ b.metric.name_en }}
              <ng-container *ngIf="b.unit">({{ b.unit.name }})</ng-container>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="false">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
      </div>

    </fieldset>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close tabindex="-1">
      {{ 'Cancel' | translate}}
    </button>

    <button mat-raised-button (click)="submitForm()" color="accent">
      {{ 'Save' | translate}}
    </button>
  </mat-dialog-actions>
</form>
